import { render } from "./FeedbackTicketDetail.vue?vue&type=template&id=2d80b5a0"
import script from "./FeedbackTicketDetail.vue?vue&type=script&lang=js"
export * from "./FeedbackTicketDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__